import React from "react";

// Omit onChange from input props to avoid conflict
interface CheckedButtonProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'onChange'> {
  checked: boolean;
  onChange: (checked: boolean) => void;
  children: React.ReactNode;
}

export const CheckedButton: React.FC<CheckedButtonProps> = ({
  checked,
  onChange,
  children,
  ...props
}) => {
  return (
    <label className={`flex items-center gap-2 px-6 py-2 rounded-lg shadow transition-all font-semibold text-base cursor-pointer border
      ${checked 
        ? "bg-primary text-background border-primary" 
        : "bg-background text-primary border-primary"
      }
    `}>
      <input
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        className={checked ? "inverse" : ""}
        {...props}
      />
      {children}
    </label>
  );
};

export default CheckedButton; 